import React, {useEffect} from 'react';
import {
    Avatar,
    Cell,
    List,
    Section,
    Headline, Image, Badge
} from '@telegram-apps/telegram-ui';
import InfoFooter from "../component/InfoFooter";
import {useNavigate} from "react-router-dom";
import toast from "react-hot-toast";
import {login_api} from "../api/UserAPI";
import {useAliveController} from "react-activation";
import WebApp from "@twa-dev/sdk";

function Fake() {
    const navigate = useNavigate()
    const aliveController = useAliveController()
    useEffect(() => {
        WebApp.setBackgroundColor("secondary_bg_color")
        WebApp.disableVerticalSwipes()
        if (WebApp.initData !== "") {
            login_api({webAppInitDataStr: WebApp.initData} as RequestAuthEntity)
                .then((res) => {
                    toast.success("登录成功，欢迎回来")
                    sessionStorage.setItem("User", JSON.stringify(res.data.data))
                    sessionStorage.setItem('X-Auth-Token', res.data.message)
                    aliveController.dropScope("Main").then(r => {
                        navigate('/Main')
                    })
                })
        } else {
            toast("欢迎了解CoinGet量化交易平台！")
            window.location.href = "https://coinget.info"
        }
    }, [])
    return (
        <List>
            <Section>
                <Cell Component="label"
                      before={<Image src={logoBase64}/>}
                      description="海量顶级公会入驻，实时推送更加稳定高效的交易策略，轻松获取投资收益！"
                      multiline>
                    <Headline weight="2"> CoinGet </Headline>
                </Cell>
                <Cell Component="label" onClick={e => {
                    window.location.href = "https://coinget.info"
                }}>
                    立即加入Coinget!
                </Cell>
            </Section>
            <Section header="🔥推荐交易员" footer={"更多优秀交易员，请前往官网查看..."}>
                <Cell Component="label" style={{whiteSpace: "pre-wrap"}} multiline
                      description={"平台上有许多优秀的交易员，他们有着丰富的经验、精准的判断和高效的执行。"}>
                </Cell>
                <Cell Component="label"
                      before={<Avatar size={48}
                                      src={"https://cdn1.coinget.info/app/images/20240103/8211890B-2C39-4DD7-9C6F-FB9C4C12B04E.jpg"}/>}
                      description={"合约策略:605\n观点:15\n盈利凭证:180\n胜率:74.07%"}
                      subtitle="订阅59/150  关注者 252"
                      multiline>
                    姚sir
                </Cell>
                <Cell Component="label"
                      before={<Avatar size={48}
                                      src={"https://cdn1.coinget.info/app/images/20240423/00246afa4a"}/>}
                      description={"合约策略:145\n观点 5\n盈利凭证:180\n胜率:63.13%"}
                      subtitle="订阅102/150  关注者 12"
                      multiline>
                    .Co❤️小
                </Cell>
            </Section>
            <Section header="🔥推荐公会" footer="抓住当前热门的合约策略，实现稳定盈利！">
                <Cell Component="label" style={{whiteSpace: "pre-wrap"}} multiline
                      description={"他们是实力雄厚的交易员团体，提供稳定高效的策略，专业全面的服务和支持。"}>
                </Cell>
                <Cell Component="label"
                      before={<Avatar src={gonghui}/>}
                      description={"浏览数:61865\t总订阅:20330\t交易员:14"}>
                    LTT公會 <Badge type={"number"}>4.6</Badge>
                </Cell>
                <Cell Component="label"
                      before={<Avatar src={gonghui}/>}
                      description={"浏览数:10095\t总订阅:2327\t交易员:7"}>
                    CPO獲利者公會 <Badge type={"number"}>4.3</Badge>
                </Cell>
                <Cell Component="label"
                      before={<Avatar src={gonghui}/>}
                      description={"浏览数:8452\t总订阅:1249\t交易员:5"}>
                    Crypto_狙擊手 <Badge type={"number"}>3.9</Badge>
                </Cell>
            </Section>
            <Headline weight="3" style={{
                textAlign: "center",
                display: "block",
                fontSize: 12,
                color: "var(--tgui--subtitle_text_color)",
                whiteSpace: "pre-wrap"
            }}>
                {"该广告仅用于外部平台投放，更多详情请前往官网：CoinGet.info\n" + "Copyright © 2024 Social Trading International INC"}
            </Headline>
        </List>
    );
}

const gonghui = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAMAAAC7m5rvAAAAAXNSR0IArs4c6QAAAPBQTFRFAAAASZK2QJ+/VZWqTp2xVZmqUJ+vR5yqUaGuTZmzSZ62TKGzSpy1UJ+vUKCvTJ+wTqCxTZ6yTZ6yTJ6wTp+xTaCyTZ+yTJ+xTqCxTZ6yTZ+wTKCxTp+xTZ+wTKCxTp+xTZ+yTZ6xTp+xTZ6xTZ+xTZ+yTZ+yTZ+xTp+xTaCxTZ6wTJ+xTZ+xTZ+xTJ+xTaCwTZ+xTZ+xTZ+xTZ+xTZ+xTZ+xTZ+xTZ+xTZ+xTZ+xTZ+xTZ+xTaCxTZ+xTZ+xTZ+xXaa2bK28erPBh7rGk8DLn8bQqs3VtdPav9jfyd7k0+Tp3Ort5e/y7vX29/r7////9pgyqQAAAD90Uk5TAAcIDA0PEBITFBUbHyAjSktMT1RVZm2Cg4SSk5SVlpeYmZqpqrK/wMLDxsjQ0dLT1NXl5+jp6vL29/j6+/z9q7aIewAAAfVJREFUSMetltlWwjAQhgNKRRFUdovWDRQBQWQRaXEKVSyr7/82thWhWZpE5b/rnHxnOlsyCG1PO0e5m1rHAKNTK+aOd6WYSObWAL+Mu0xEBCWuekCrd53gQYpqAFuGqgRSqRYEq5ViQ+Fz4EsLM6i9CohU2aOoWBPEasYIKloHGdX3MSpUBTlVQ35MA1lp/sxvzNYHprFFcps6KL56fXwSWk5MvH7ruqvAwRxwhHHqijrU+RjB6XFGPjxsHZo997gZIyvRHoX5vt+WrgFz1/OaJQs8DMaee+xM1sXKfMx0DVPsTNlt4QEfAzq4gfOXSZDAcG+QROhUgI3o2OAUoZIAm7qGIX6ohFCdiw2njH+EBkJdBvZT7dl3tecmgT0hpDMwXDZJwTNCIMJmFj11Mt7IPHreWLFZK73bC4+z6Nj4mTQnrEw+CutmLqm28eom6hLbNZhUl4h68p0RXFI8ARaNuRMgmjevlcfUvImmGwKmO/oixibYXRINuLkwbOYYFoz7PG5wMZvIibG6J1GBiw3dgi82lTtbvwFtkFd78/anf4Gl//2+obD0a4pvCwdyb3fjYCubwl/3Eie+CwF1GQ7YuXj1a6eCN7yCHgDpBYW3Gsa1PgPqa3HRIqpk7ont9T6jSO29uyf5Yq37Cq/dh2L+hLUrfwEm0zHe49oTjgAAAABJRU5ErkJggg=="
const logoBase64 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAEnklEQVRogc2Z0WsUVxTGf3fcBFFoWLuwtDZGYmJ3tWlBGiwErBAi1CJCjEsFFZEKiVZLQx6SB/+DQkAIFg1WqCGgD6JgER9EY0QaAoHuYgwG0yRNNCgbH6KR1MzXB5vVzcxund2J6weXhTlnv/PbM/fO3NkxuEjSeuA74EvgCyAIzLvl+iwDWMDfwJ9AD9BpjJnL+i1JRtIJvV8ak9SUDfpDSQMFhsym04tPzQJ4HPgs97P8TtRujGmGV/MJST/z/kMD/CTpGwAj6RNgvMBAXjRkjIlYwPeFJvGoTyXVWMBXhSbJQd9awOdLWSGZTHLv3j1mZmb8tA1bwAd+OgJcuXKFlpYWampqKC0tJRqNcvv2bT9LmADwj19uZ86cob29nUQi4ZdlJtkBP1wmJibYu3cvN27cyJgTCPhS6rVfvgb9/f1s27aN6enprHnPnj3Lt1Sa8gKPx+Ns3rwZ27Yz5lRUVFBRUUF5eXk+pZySNJ3LxuHly5cqKSkR4BhFRUVqbW3V/fv3/duppKszZ/BYLOYKXVdXp0ePHqXyHjx4oPPnz2t0dNQvaClX8EQi4Qodi8VeO3d2asOGDanY1atXCw++Y8cOB/TGjRtT8QMHDjjivb29hQV//Pixa7dHRkYkSUeOHHGNX79+3Vdwy+ti7unpcRyrra1l7dq19PX10dHR4YgvW7aMYDDotVR2ee347t27Hd28cOGCJCkajTpiLS0tGhsb87PbktTp+TpeV1dHWVkZlmUhCYD6+vrU59zcHMYYbNsmGo1y8OBBAFpbW+nv73f1bGxspKGhYWk7nqtWr17tOvcBtbW1ebXz3vHu7m6ePHmS6nggEKCxsRHbtjl58iTLly9P5e7cuZNQKATAunXrmJiYYNWqVTx9+jTtbpvT/JfHjkciEUfHZmdnZdu24/iuXbtS33v+/Lkk6ezZs7IsKy2vq6vLc8c9gx8/ftwB2N3dLUnav3+/I3bs2LHU4rx165brAn748OHSg1+6dMlReOvWrZKkgYEB1zkcCAQUCoVcY/v27fMKnRt4Mpl0BVjYUDU3N2dchItHSUmJXrx48W7AJam+vt4BEY1GU/Gmpqb/hS4vL9fw8HAu0LmD37171xWmoaEhlXPu3DlVVVU5ckKhkA4fPpxrp/MDl6Q9e/a4wtfW1mpycjKVNz4+rsuXL6urq0t37tzRzMxMPsD5g8/PzysYDGZ8kGhra3s/HyQkKR6PO67Ji0dlZaW2b9+uoaEhH7nzBJekvr6+jI9wb45r1675xCwpl23tYlVXVxOPx9myZUvWvBUrVuRbKk15gwOUlpZy8+ZNTp06RSQScc3J9k9ALrKAIr/MDh06xODgIBcvXuTo0aNs2rSJ4uJigNQW2CdZRtIk8JGfrm9qamqKZDLJmjVrWLlypV+2vwaABEsIHg6HCYfDfttOWcAffru+A/1uJJUBfxWaxIOGjTGVljFmFDhRaBoPaob014VDwPqC4bydOowxP0D6dfxrYLAwPG+l3xagHZJULOkXP+/NPmhK0o+LWU2GH1AFxIBq4GNe3aQW9h1LKfPfmAVGgF7gtDHG8ebrX9CdgK4GgaG/AAAAAElFTkSuQmCC"
export default Fake;
